module.exports = __webpack_public_path__ + "media/application/images/icons/soundcloud-99c9108e1d7f511edf8295d2c6c22337.svg";